// extracted by mini-css-extract-plugin
module.exports = {"background":"Author_background__1BBsS","icon":"Author_icon__1adLw","text":"Author_text__1FG3M","signature":"Author_signature__2BJ6M"};